<div class="bdo-trustpilot-widget re-w-full re-mt-45 lg:re-mt-60 re-bg-white re-px-15 md:re-px-30 re-py-30 md:re-py-30">
  <h4 class="re-mb-20 md:re-mb-30">
    {{ 'summary.trust.title' | translate }}
  </h4>
  <div class="re-w-full">
    <div #trustbox
         class="trustpilot-widget"
         [attr.data-locale]="locale"
         [attr.data-template-id]="templateId()"
         [attr.data-businessunit-id]="businessunitId()"
         [attr.data-style-height]="height()"
         [attr.data-style-width]="width()"
         [attr.data-theme]="theme()"
         [attr.data-stars]="stars()"
         [attr.data-review-languages]="reviewLanguages">
      <a [href]="profileUrl" target="_blank" rel="noopener noreferrer">Trustpilot</a>
    </div>
  </div>
</div>
